import React from 'react'
import {
  MDBFooter,
  MDBContainer
} from 'mdb-react-ui-kit';
import watsapp from '../Images/whatsapp.png'
import '../App.css'
function Footer() {
  return (
    <div>
            <MDBFooter className='bg-dark text-center text-white'>
      <MDBContainer className='p-4 pb-0'>
        
        <div className='row w-100'>
            <div className='col-4'></div>
            <div className='mb-2 col-4 d-flex justify-content-evenly'>
              <a target='_bind' href="https://wa.me/9961750288"><img width={30} src={watsapp} alt="" /></a>
              <a   href="tel:9961750288"><i class="fa-solid fa-xl fa-phone-volume"></i></a>
            </div>
            <div className='col-4'></div>
        </div>
      </MDBContainer>

      <div className='text-center p-3' style={{ backgroundColor: 'rgba(0, 0, 0, 0.2)' }}>
        © 2024 Copyright : 
        <a className='text-white' target='_bind' href='https://www.google.com/search?q=vallikunnil+medicals&oq=vallikunni&gs_lcrp=EgZjaHJvbWUqBggBEEUYOzIGCAAQRRg5MgYIARBFGDsyBggCEEUYQNIBCDI3OTRqMGo3qAIAsAIA&sourceid=chrome&ie=UTF-8'>
        <span> VallikunnilMedicals</span>
        </a>
      </div>
    </MDBFooter>
    </div>
  )
}

export default Footer